<template>
  <button class="weui_btn" :class="classes" :disabled="disabled" @click="onClick">
    {{text}}
    <slot></slot>
  </button>
</template>
<script>
export default {
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    cssClasses: String
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  },
  computed: {
    classes() {
      return [{
        weui_btn_disabled: this.disabled,
        weui_btn_mini: this.mini
      },
      `weui_btn_${this.type}`,
      this.plain ? `weui_btn_plain_${this.type}` : '',
      this.cssClasses
      ]
    }
  }
}
</script>
<style lang="less">
@import '../../styles/cui/widget/cui_button/cui_button.less';
</style>



// WEBPACK FOOTER //
// x-button.vue?99aabca0